import React, { Component, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { login, logout } from "../../redux/logger/logActions";

import {
  CalendarMonth,
  HorizontalSplit,
  HourglassEmpty,
  LanguageOutlined,
  ChevronRight,
  Favorite,
  Person,
  LocalLibraryOutlined,
  LocalLibrarySharp,
  PlaylistAdd,
  NotificationsActive,
} from "@mui/icons-material";
import { Typography, CircularProgress, Button } from "@mui/material";
import { useParams } from "react-router-dom";
import axios from "axios";
import { basePath } from "../../utility";

import MyApplications from "./MyApplications";
import Notifications from "./Nofifications";
import Applications from "../AddApplication/Applications";

const Dashboard = ({ currentTab, setCurrentTab }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const logger = useSelector((state) => {
    return state.logger;
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (!logger.user.name) {
      navigate("/");
    } else {
      // console.log(logger.user);
    }
  }, []);

  const loadApplications = async () => {
    try {
      let user = logger.user;

      let userApplications = [];
      let userId = logger.user.userId;

      const getUserApplications = await axios.get(
        `${basePath.url}application/my-applications/${userId}`
      );

      // console.log(getUserApplications);
      userApplications = [...getUserApplications.data.data];

      user.userApplications = userApplications;

      dispatch(login(user));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // loadApplications();
  }, []);

  const showTab = (currentTab) => {
    switch (currentTab) {
      case "My Applications":
        return (
          <MyApplications
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
          />
        );
      case "Notifications":
        return <Notifications />;
      case "Add New":
        return <Applications />;
      default:
        break;
    }
  };

  return (
    <>
      <div
        className="fullWidthWrapperMain"
        style={{ backgroundColor: "transparent" }}
      >
        <div className="mainBannerWrapper">
          <div className="bookPreviewWrapper" style={{ borderBottom: "none" }}>
            <div
              className="mainContent"
              style={{
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              <>
                {logger.user.name ? (
                  <>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 10,
                        borderBottom: "1px solid #999",
                        flexWrap: "wrap",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          gap: 10,
                          borderBottom: "0px",
                          // width: "100%",
                          boxSizing: "border-box",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {!logger.user.avatar ? (
                            <Person
                              style={{
                                width: 50,
                                border: "1px solid #ccc",
                                fontSize: 50,
                                borderRadius: "50%",
                                padding: 5,
                                color: "#2d3e50",
                              }}
                            />
                          ) : null}
                        </div>

                        <div
                          className="header"
                          style={{ borderBottom: "0px", width: "auto" }}
                        >
                          <Typography
                            variant="subtitle1"
                            style={{ fontSize: "1.25rem" }}
                          >
                            {logger.user.name}
                          </Typography>
                          <Typography
                            variant="subtitle1"
                            style={{ fontSize: "0.75rem", color: "grey" }}
                          >
                            {logger.user.email}
                          </Typography>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                          alignItems: "center",

                          // gap: 10,
                        }}
                      >
                        <Button
                          variant="outlined"
                          style={{ border: "none" }}
                          onClick={() => {
                            setCurrentTab("My Applications");
                          }}
                        >
                          My Applications
                          <span style={{ color: "#444", fontSize: 11 }}>
                            (
                            {logger.user.userApplications &&
                              logger.user?.userApplications.length}
                            )
                          </span>
                        </Button>

                        <Button
                          variant="outlined"
                          style={{ border: "none" }}
                          onClick={() => {
                            setCurrentTab("Notifications");
                          }}
                        >
                          <NotificationsActive />
                        </Button>
                      </div>
                    </div>
                    <div className="contentBody">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 5,
                          width: "100%",
                          marginBottom: 50,
                          flexWrap: "wrap",
                          margin: 10,
                          boxSizing: "border-box",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 5,
                            width: "auto",
                          }}
                        >
                          <ChevronRight />
                          <Typography
                            variant="subtitle2"
                            style={{ marginTop: 0, padding: 0 }}
                          >
                            {currentTab}
                          </Typography>
                        </div>
                        <div>
                          <Button
                            size="medium"
                            variant="outlined"
                            style={{
                              color: "#444",
                              borderColor: "#444",
                              textTransform: "capitalize",
                              border: "none",
                            }}
                            startIcon={<PlaylistAdd color="success" />}
                            onClick={() => {
                              setCurrentTab("Add New");
                            }}
                          >
                            Add New Application
                          </Button>
                        </div>
                      </div>

                      <div
                        style={{
                          minHeight: "100%",
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          boxSizing: "border-box",
                        }}
                      >
                        {/* {logger.user.userPurchasedBooks.length < 1 ? (
                          <div
                            style={{
                              padding: 100,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <LocalLibraryOutlined
                              style={{ fontSize: 100, color: "#444" }}
                            />
                            <Typography variant="subtitle2">
                              No books Purchased!
                            </Typography>
                          </div>
                        ) : null} */}
                        {showTab(currentTab)}
                      </div>
                    </div>
                  </>
                ) : null}
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
